module.exports = {
    actions: {
        USER_REQUESTED: 'USER_REQUESTED',
        PRESELECTED: 'PRESELECTED',
        AUTOMATICALLY_ADDED: 'AUTOMATICALLY_ADDED',
    },
    targets: {
        UNKNOWN: 'UNKNOWN',
        BUSINESS_LOGIC: 'BUSINESS_LOGIC',
        WIDGET: 'WIDGET',
        CONTINUE_BUTTON: 'CONTINUE_BUTTON',
        FARE_RULES: 'FARE_RULES',
    },
};
